export default "/assets/website/images/2026.jpg?c480ca66626ad277648d19d72f325236";